@if (app()) {
	<div class="detail-page__header">
		<div class="list-page__header-actions">
			<div></div>
			<p-button (onClick)="showDeployWizard()">
				<span class="material-symbols-outlined me-2">rocket_launch</span>
				{{
					'DEPLOYMENTS_AND_INSTANCES.BUTTONS.DEPLOY' | transloco | apwUcfirst
				}}
			</p-button>
		</div>
	</div>
}
<div class="detail-page__content d-flex flex-column">
	<p-tabs [value]="activeTab()">
		<p-tablist>
			@for (tab of filteredTabs(); track tab.route) {
				<p-tab
					[value]="tab.route"
					[routerLink]="
						app()
							? ['/apps', app().id, 'deployments', tab.route]
							: ['/deployments', tab.route]
					"
				>
					{{ tab.label | transloco | apwUcfirst }}
				</p-tab>
			}
		</p-tablist>
	</p-tabs>
	<div class="flex-fill overflow-auto pt-3">
		<router-outlet />
	</div>
</div>
